import React, { useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
  useMediaQuery,
  Stack,
} from "@mui/material";
import SignaturePad from "react-signature-canvas";
import { useTranslation } from "react-i18next";
import { Close } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

const SignatureDialog = ({ open, onClose, onSave ,onClear }) => {
  const theme = useTheme();
  const sigPadRef = useRef(null);
  const { t } = useTranslation();
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const classes = useStyles();
 
  const handleClear = () => {
  sigPadRef.current?.clear();
    if (onClear) {
      onClear();
    }
  };

  const handleSave = () => {
    const dataUrl = sigPadRef.current.getTrimmedCanvas().toDataURL("image/png");
    const base64 = dataUrl.split(",")[1];

    onSave({
      content: base64
    });
  };


  return (
    <Dialog 
    fullScreen={fullScreen}
    fullWidth
     open={open} 
     onClose={onClose} 
     aria-labelledby='customized-dialog-title' maxWidth="sm" 
     PaperProps={{
        sx: {
          maxWidth: "none",
          width: 1200,
        }
      }}
      >
   <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <Stack
                        direction="row"
                        sx={{
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}>
                        <Typography variant="h6" component="div">
                            {t('general.signature')}
                        </Typography>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={onClose}
                            aria-label="close"
                        >
                            <Close sx={{ cursor: "pointer" }} />
                        </IconButton>
                    </Stack>
                </Toolbar>
            </AppBar>
      <DialogContent>
        <Stack sx={{height:'100%'}}>
          <div className={classes.signatureMainContainer}>
            <div className={classes.signatureContainer}>
              <SignaturePad
                ref={sigPadRef}
                penColor="black"
                canvasProps={{ className: classes.signaturePad }}

              />
            </div>
          </div>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClear}>{t("survey.clear")}</Button>
        <Button onClick={onClose}>{t("general.close")}</Button>
        <Button variant="contained" onClick={handleSave}>
          {t("general.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureDialog;
const useStyles = makeStyles(theme => ({
    signatureMainContainer: {
        width: '100%',
        height:'100%'
    },
    signatureContainer: {
        height:"100%",
        width: '100%',
        margin: '0 auto',
        backgroundColor: theme.palette.grey[100],
        borderRadius: 7,
        aspectRatio: '16 / 9',
    },
    signaturePad: {
        width: '100%',
        height: '100%',
    },
}));
